module.exports = __webpack_public_path__ + "media/sapa_archive/SAPAbg620x50v2-3248ad80.png";